import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind classes with clsx for conditional class composition.
 * Handles conflicts gracefully (e.g., `cn('p-4', 'p-8')` → 'p-8')
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
